import {
  SUMMARY_PRIMARY_CONFIG,
  SUMMARY_SECONDARY_CONFIG,
} from './summaryConfig';
import { formatValue } from './summaryFormatters';
import { useState } from 'react';

export default function SummaryBar({
  primary,
  secondary,
  isSingleAsin
}) {
  const context = { isSingleAsin};
  const [isExpanded, setIsExpanded] = useState(false);
  const renderCell = (cfg, source) => {
    const value = source?.[cfg.key];
    if (value == null) return null;
    if (cfg.visibleWhen && !cfg.visibleWhen(context)) return null;

    const tone = cfg.toneResolver
      ? cfg.toneResolver(value, context)
      : 'neutral';

    return (
      <div
        key={cfg.key}
        className="cell"
        data-tone={tone}
        data-emphasis={cfg.emphasis}
      >
        <div className="value">{formatValue(value, cfg.format)}</div>
        <div className="label">{cfg.label}</div>
      </div>
    );
  };

  return (
    <div className="summary-bar">
      {/* PRIMARY */}
      <div className="primary">
        {SUMMARY_PRIMARY_CONFIG.map((cfg) =>
          renderCell(cfg, primary)
        )}
      </div>

      <div
        className="summary-toggle"
        onClick={() => setIsExpanded(v => !v)}
      >
        {isExpanded ? 'Hide details' : 'Show details'}
      </div>

      {/* SECONDARY */}
      {secondary && (
        <div
          className="secondary"
          data-expanded={isExpanded}
        >
          {SUMMARY_SECONDARY_CONFIG
            .filter(group =>
              !group.visibleWhen || group.visibleWhen(context)
            )
            .map((group) => (
            <div key={group.group} className="group">
              <div className="title">{group.group}</div>
              <div className="items">
                {group.items.map((cfg) =>
                  renderCell(cfg, secondary)
                )}
              </div>
            </div>
          ))}
        </div>
      )}

    </div>
  );
}
